var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59379 13.1738L17.3731 20.8984C17.4745 20.9883 17.5976 21.0501 17.7302 21.078C17.8628 21.1059 18.0004 21.0988 18.1295 21.0574C18.2585 21.0161 18.3746 20.9418 18.4662 20.842C18.5579 20.7423 18.6221 20.6204 18.6524 20.4883L22.3243 4.45312C22.3551 4.31503 22.3478 4.17116 22.3032 4.03689C22.2586 3.90261 22.1784 3.78297 22.0711 3.69072C21.9638 3.59848 21.8335 3.5371 21.694 3.51315C21.5546 3.48919 21.4113 3.50354 21.2793 3.55469L3.25199 10.6348C2.52934 10.918 2.627 11.9727 3.38871 12.1289L8.59379 13.1738Z",
    stroke: "#C1C7CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 13.1738L21.8848 3.57422",
    stroke: "#C1C7CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9785 17.0312L9.93164 20.0781C9.82294 20.1885 9.68388 20.2641 9.53213 20.2952C9.38038 20.3264 9.2228 20.3117 9.0794 20.2531C8.936 20.1945 8.81327 20.0946 8.72679 19.966C8.64032 19.8375 8.59401 19.6862 8.59375 19.5313V13.1738",
    stroke: "#C1C7CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/TelegramLogo.0f3c6153b5c069e1b0dbb39e0d08fc09.svg";
export { ForwardRef as ReactComponent };